export default __webpack_public_path__ + "static/media/support_light_mode.df749d1d.svg";